

import React from 'react';
import { FaRocket, FaChartLine, FaUsers, FaCheckCircle, FaCogs, FaClipboardList, FaRegLightbulb, FaShieldAlt, FaBalanceScale } from 'react-icons/fa';
import './Contato.css';

const Inicio = () => {
  return (
    <div className="suporte-container">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-content">
          <h1 className="hero-title">ProcessStepWise</h1>
          <p className="hero-subtitle">A inteligência que transforma sua indústria</p>
          <div className="hero-badge">Gestão, automação e controle em um só lugar</div>
        </div>
      </section>

      {/* Frase de impacto */}
      <section className="about-section">
        <div className="about-content">
          <h2 className="section-title">Bem-vindo ao futuro da gestão industrial</h2>
          <p className="about-description">
            O <strong>ProcessStepWise</strong> é a plataforma definitiva para quem busca eficiência, inovação e resultados reais. Com tecnologia de ponta, integra todos os setores da sua produção, automatiza tarefas, reduz desperdícios e potencializa a tomada de decisão.
          </p>

          {/* Benefícios rápidos */}
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon"><FaRocket /></div>
              <h3>Produtividade Elevada</h3>
              <p>Otimize processos, elimine gargalos e aumente a performance do seu time.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon"><FaChartLine /></div>
              <h3>Visão em Tempo Real</h3>
              <p>Monitore indicadores, acompanhe o chão de fábrica e antecipe decisões.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon"><FaRegLightbulb /></div>
              <h3>Inovação Contínua</h3>
              <p>Ferramentas inteligentes para evoluir junto com o mercado.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon"><FaShieldAlt /></div>
              <h3>Segurança e Qualidade</h3>
              <p>Controle rigoroso de qualidade, rastreabilidade e conformidade.</p>
            </div>
          </div>
        </div>
      </section>

      {/* O que o ProcessStepWise faz */}
      <section className="about-section">
        <div className="about-content">
          <h2 className="section-title">O que o ProcessStepWise faz?</h2>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon"><FaCogs /></div>
              <h3>Automação de Processos</h3>
              <p>Reduza tarefas manuais, padronize operações e ganhe tempo em cada etapa da produção.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon"><FaClipboardList /></div>
              <h3>Gestão Integrada</h3>
              <p>Centralize informações de fornecedores, insumos, produtos, fichas técnicas e qualidade.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon"><FaBalanceScale /></div>
              <h3>Consumo Preciso e Custo Real</h3>
              <p>Realize o consumo detalhado das peças do calçado e obtenha o custo exato de cada produto, facilitando a precificação e a gestão de margens.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon"><FaUsers /></div>
              <h3>Controle de Equipes</h3>
              <p>Gerencie perfis, usuários e permissões, garantindo segurança e produtividade.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon"><FaCheckCircle /></div>
              <h3>Qualidade Total</h3>
              <p>Implemente cronoanálise, testes de calce e garanta excelência em cada produto.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Módulos do Sistema */}
      <section className="modules-section">
        <h2 className="section-title">Módulos do Sistema</h2>
        <div className="modules-list">
          <div className="module-item"><span className="module-bullet">•</span><span>Gestão de Fornecedores</span></div>
          <div className="module-item"><span className="module-bullet">•</span><span>Controle de Matéria-Prima</span></div>
          <div className="module-item"><span className="module-bullet">•</span><span>Cadastro de Produtos e Ficha Técnica</span></div>
          <div className="module-item"><span className="module-bullet">•</span><span>Cronoanálise de Processos</span></div>
          <div className="module-item"><span className="module-bullet">•</span><span>Controle de Qualidade</span></div>
          <div className="module-item"><span className="module-bullet">•</span><span>Gestão de Perfis e Usuários</span></div>
          <div className="module-item"><span className="module-bullet">•</span><span>Sistema MES (Manufacturing Execution System)</span></div>
          <div className="module-item"><span className="module-bullet">•</span><span>Catálogo Virtual de Produtos</span></div>
        </div>
      </section>

      {/* Footer */}
      <footer className="suporte-footer">
        <p>&copy; 2025 ProcessStepWise - Todos os direitos reservados</p>
        <p className="footer-tagline">Sua indústria mais inteligente, eficiente e competitiva.</p>
      </footer>
    </div>
  );
};

export default Inicio;